const override = null

const MODE = override || process.env.REACT_APP_NODE_ENV

export const backendURL = MODE === 'development' ? 'http://localhost:5050' : 'https://togsurveys-server.herokuapp.com'

export const getStarCount = id => [5, 9, 20].includes(id) ? 10 : 5